import Vue from 'vue';
import Vuex from 'vuex';
import tokenStatus from './modules/tokenStatus'
import cityInfo from './modules/cityInfo'
import area from './modules/area'
//...
Vue.use(Vuex);

export default new Vuex.Store({
    modules:{
        tokenStatus,
        cityInfo,
        area,
        //...
    },
    state:{
        userInfo:"",
        hasLogin: false
    },
    mutations:{
        login(state, provider) {
            state.hasLogin = true
            state.userInfo = provider
            localStorage.setItem('userInfo',JSON.stringify(provider))
        },
        signOut(state) {
            state.hasLogin = false
            state.userInfo = {
            }
            localStorage.removeItem('userInfo')
        }
    }
});